import { render } from "./IdeaFilter.vue?vue&type=template&id=10c379df&scoped=true&ts=true"
import script from "./IdeaFilter.vue?vue&type=script&lang=ts"
export * from "./IdeaFilter.vue?vue&type=script&lang=ts"

import "./IdeaFilter.vue?vue&type=style&index=0&id=10c379df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c379df"]])

export default __exports__